import { messageHttpFailure } from "./http-message.ts";
import { Schema } from "effect";
import { StationTag } from "../history/station.ts";

export const HistoryValidationError = /* @__PURE__ */ (() => class HistoryValidationError extends messageHttpFailure<HistoryValidationError>()("HistoryValidationError", 400) {})();
export type HistoryValidationError = InstanceType<typeof HistoryValidationError>;

export const HistoryNotFoundError = /* @__PURE__ */ (() => class HistoryNotFoundError extends messageHttpFailure<HistoryNotFoundError>()("HistoryNotFoundError", 404) {})();
export type HistoryNotFoundError = InstanceType<typeof HistoryNotFoundError>;

export const HistoryConflictError = /* @__PURE__ */ (() => {
  class HistoryConflictError extends Schema.TaggedError<HistoryConflictError>()("HistoryConflictError", {
    message: Schema.String, status: Schema.tag(409),
    currentUpdatedAt: Schema.optionalKey(Schema.NullOr(Schema.Number)),
    backupTag: Schema.optionalKey(StationTag),
    observedRevision: Schema.optionalKey(Schema.Number),
    observedCommitId: Schema.optionalKey(Schema.NullOr(Schema.String))
  }) {}
  return HistoryConflictError;
})();
export type HistoryConflictError = InstanceType<typeof HistoryConflictError>;

export const HistoryMethodNotAllowedError = /* @__PURE__ */ (() => class HistoryMethodNotAllowedError extends messageHttpFailure<HistoryMethodNotAllowedError>()("HistoryMethodNotAllowedError", 405) {})();
export type HistoryMethodNotAllowedError = InstanceType<typeof HistoryMethodNotAllowedError>;

export type HistoryFailure = HistoryValidationError | HistoryNotFoundError | HistoryConflictError | HistoryMethodNotAllowedError;
